/* Zoci size guide (snippets/zoci-size-guide.liquid): tabs, the scroll dial, measurement to size
   (mm, cm or inches read by range; a ring's or bangle's width across; a bangle size like 2.6),
   the actual-size ring (calibrated against a bank card), the bracelet on a wrist, the chain
   dress form, saved fit, and the product-page drawer (snippets/zoci-pdp-size.liquid).
   The size tables in the markup are the only copy of the data; everything here reads them. */
(function () {
  if (window.ZociSizeGuide) return;
  var FIT = 'zoci_fit', PXMM = 'zoci_pxmm', CARD_MM = 53.98;
  // Chain depth on the dress form, [inches, y]: read off the owner's PDF figure (chain bottom below the
  // neck base, rescaled to this form). Not linear: short lengths bunch at the neck, long ones fall away.
  var DROP = [[14, 113], [16, 142], [18, 161], [20, 174], [21, 180], [22, 189], [24, 205], [26, 228], [28, 251], [36, 342], [42, 394], [50, 430]];
  var coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Storage can be blocked (some private modes, in-app browsers). MEM keeps the size for this visit,
  // so a required size can still be saved and the piece still goes in the bag.
  var MEM = {};
  function get(k) { try { var v = localStorage.getItem(k); if (v != null) return JSON.parse(v); } catch (e) {} return k in MEM ? MEM[k] : null; }
  function put(k, v) { MEM[k] = v; try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function drop(k) { delete MEM[k]; try { localStorage.removeItem(k); } catch (e) {} }
  // CSS pixels per real millimetre. Phones run ~6.2, laptops ~4.6; a card makes it exact.
  function scale() { var c = get(PXMM); return c > 2 && c < 12 ? { v: c, real: true } : { v: coarse ? 6.2 : 4.6, real: false }; }
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function fmt(n) { return (Math.round(n * 10) / 10).toString(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Dial: a scroll-snap ruler; native momentum on phones, arrows and Home/End on keyboards ---------- */
  function Dial(el, onPick) {
    var stops = el.querySelectorAll('.zsg-dial__stop'), w = 0, idx = -1, quiet = 0, raf = 0, self = this;
    function width() { if (stops[0]) w = stops[0].getBoundingClientRect().width; return w; }
    function clamp(i) { return Math.max(0, Math.min(stops.length - 1, i)); }
    function paint(i) {
      stops.forEach(function (s, n) { s.classList.toggle('is-on', n === i); s.setAttribute('aria-hidden', 'true'); });
      el.setAttribute('aria-valuenow', i + 1);
      el.setAttribute('aria-valuetext', stops[i].dataset.text || stops[i].textContent.trim());
    }
    this.set = function (i, smooth) {
      i = clamp(i); if (!width()) { idx = i; paint(i); return; }
      quiet = Date.now() + (smooth ? 700 : 80);
      el.scrollTo({ left: i * w, behavior: smooth && !still ? 'smooth' : 'auto' });
      if (i !== idx) { idx = i; paint(i); }
    };
    this.sync = function () { if (idx >= 0) self.set(idx, false); };
    el.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0; if (!width()) return;
        var i = clamp(Math.round(el.scrollLeft / w));
        if (i === idx) return;
        idx = i; paint(i);
        if (Date.now() > quiet) { onPick(i, 'dial'); if (coarse && navigator.vibrate) navigator.vibrate(4); }
      });
    }, { passive: true });
    var drag = null, moved = false;
    stops.forEach(function (s, n) { s.addEventListener('click', function () { if (moved) return; self.set(n, true); onPick(n, 'tap'); }); });
    // Mouse: drag the ruler like a phone would. Touch already scrolls natively.
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: el.scrollLeft }; moved = false;
      el.style.scrollSnapType = 'none'; el.classList.add('is-grabbing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x; if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null; el.style.scrollSnapType = ''; el.classList.remove('is-grabbing');
      if (moved) { self.set(Math.round(el.scrollLeft / (w || width())), true); setTimeout(function () { moved = false; }, 0); }
    });
    el.addEventListener('keydown', function (e) {
      var d = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1, PageDown: -5, PageUp: 5 }[e.key];
      var to = e.key === 'Home' ? 0 : e.key === 'End' ? stops.length - 1 : d != null ? clamp(idx + d) : null;
      if (to == null) return;
      e.preventDefault(); self.set(to, true); onPick(to, 'key');
    });
  }

  /* ---------- One tab: ring, bracelet, bangle or chain ---------- */
  // units: [low, high, unit, mm per unit]. The ranges never overlap for one body part, so whatever
  // people type (52, 5.2, 2.05 for a finger; 158, 15.8, 6.2 for a wrist) reads one way only.
  // across: the inside width of a piece they already own, matched on the table's "across" column.
  var KIND = {
    ring: {
      big: function (r) { return r.v; }, label: function () { return 'Indian ring size'; },
      meta: function (r) { return fmt(num(r.c)) + ' mm around'; },
      saved: function (r) { return 'Size ' + r.v + ' · ' + fmt(num(r.c)) + ' mm'; },
      units: [[38, 80, 'mm', 1], [3.8, 8, 'cm', 10], [1.5, 3.2, 'in', 25.4]], across: [12, 24, 0.15], exact: 0.6, sizes: 'ring size ', noun: 'ring',
      wait: 'Type the length around your finger, e.g. 52 mm.', what: 'finger'
    },
    bangle: {
      big: function (r) { return r.v; }, label: function () { return 'Bangle size'; },
      meta: function (r) { return fmt(num(r.c)) + ' mm around'; },
      saved: function (r) { return 'Size ' + r.v + ' · ' + r.d + ' mm across'; },
      units: [[150, 280, 'mm', 1], [15, 28, 'cm', 10], [6, 11, 'in', 25.4]], across: [48, 85, 0.5], exact: 1, labels: true, noun: 'bangle',
      wait: 'Type the length around your folded hand, e.g. 185 mm.', what: 'hand'
    },
    bracelet: {
      big: function (r) { return r.v; }, label: function (r) { return r.name; },
      meta: function (r) { return 'For wrists ' + r.lo + '–' + r.hi + ' mm'; },
      saved: function (r) { return 'Size ' + r.v + ' · ' + r.lo + '–' + r.hi + ' mm'; },
      units: [[100, 260, 'mm', 1], [10, 26, 'cm', 10], [3.9, 10, 'in', 25.4]],
      wait: 'Type the length around your wrist bone, e.g. 158 mm.', what: 'wrist'
    },
    chain: {
      big: function (r) { return r.v + '<small> in</small>'; }, label: function (r) { return r.name; },
      meta: function (r) { return r.where; },
      saved: function (r) { return r.v + ' in · ' + r.name; },
      // 25 to 60 is a real chain in inches or in cm (45: a long chain, or an 18 in one): ask, never guess.
      units: [[10, 60, 'in', 25.4], [25, 152, 'cm', 10], [250, 1520, 'mm', 1]], unit: 'in', both: true, noun: 'chain',
      wait: 'Type the whole length, clasp to clasp, e.g. 18 in or 45 cm.', what: 'chain'
    }
  };
  // Typed text to a size: { i?, m (mm the size was matched on), unit, note, said } | { wait } | { big }
  // | { ask: [a, b] } when a whole number is both a ring size and a measurement ("16": size 16, or 16 mm across?).
  function read(K, rows, s) {
    var x = num(s); if (!(x > 0)) return null;
    if (K.sizes && /^\d{1,2}$/.test(s)) {
      for (var q = 0; q < rows.length; q++) if (rows[q].v === s) {
        var asSize = { i: q, m: num(rows[q].c), unit: 'size', note: '', exact: true, said: K.sizes + s };
        var asMm = measure(K, rows, s, x);
        return asMm && asMm.m ? { ask: [asSize, asMm] } : asSize;
      }
    }
    if (K.both) {
      var hits = K.units.filter(function (U) { return x >= U[0] && x <= U[1]; });
      if (hits.length > 1) return { ask: hits.map(function (U) { return measure({ units: [U], what: K.what }, rows, s, x); }) };
    }
    return measure(K, rows, s, x);
  }
  function measure(K, rows, s, x) {
    if (K.labels) { // a bangle size as people say it: 2.6, 2-6, 2/6, 3
      var lab = s.replace(/\s/g, '').replace(/[.\/]/, '-');
      for (var n = 0; n < rows.length; n++) if (rows[n].v === lab) return { i: n, m: num(rows[n].c), unit: 'size', note: '', exact: true };
    }
    if (K.across && x >= K.across[0] && x < K.across[1]) {
      for (var j = 0; j < rows.length; j++) if (num(rows[j].d) >= x - K.across[2]) {
        return { i: j, m: num(rows[j].c), unit: 'mm', note: 'Read as ' + s + ' mm across the inside of a ' + K.noun + ' you own. ', exact: Math.abs(num(rows[j].d) - x) <= K.across[2], said: s + ' mm across a ' + K.noun + ' you own' };
      }
      return { big: true, unit: 'mm' };
    }
    for (var u = 0; u < K.units.length; u++) {
      var U = K.units[u]; if (x < U[0] || x > U[1]) continue;
      var m = x * U[3];
      var word = U[2] === 'in' ? 'inches' : U[2];
      if (K.what === 'chain') return { m: m, unit: U[2], note: U[2] === 'in' ? '' : 'Read as ' + s + ' ' + word + ', which is ' + fmt(m / 25.4) + ' in. ', said: s + ' ' + word };
      return { m: m, unit: U[2], note: U[3] === 1 ? '' : 'Read as ' + s + ' ' + word + ', which is ' + fmt(m) + ' mm. ', said: s + ' ' + word + ' around your ' + K.what };
    }
    return x > K.units[0][1] ? { big: true, unit: 'mm' } : { wait: true };
  }

  function Panel(el, guide) {
    var self = this, kind = el.dataset.kind, K = KIND[kind];
    var rows = [].map.call(el.querySelectorAll('tr[data-v]'), function (tr) { var o = Object.assign({}, tr.dataset); o.tr = tr; return o; });
    var big = el.querySelector('[data-zsg-big]'), label = el.querySelector('[data-zsg-label]'), meta = el.querySelector('[data-zsg-meta]');
    var input = el.querySelector('[data-zsg-input]'), out = el.querySelector('[data-zsg-out]'), live = el.querySelector('[data-zsg-live]');
    var save = el.querySelector('[data-zsg-save]'), wa = el.querySelector('[data-zsg-wa]'), badge = el.querySelector('[data-zsg-scale]');
    var unit = el.querySelector('[data-zsg-unit]'), dim = el.querySelector('[data-zsg-dim]');
    var cur = 0, measured = null;
    this.kind = kind;

    var dialEl = el.querySelector('.zsg-dial'); // bracelets have none: their size chips are the selector
    var dial = dialEl ? new Dial(dialEl, function (i) { clearInput(); pick(i, false); }) : { set: function () {}, sync: function () {} };
    var hint = el.querySelector('[data-zsg-hint]'), matchTip = el.querySelector('[data-zsg-match]');
    // Know your size already? All sizes as buttons: one tap instead of swiping from 12 to 25.
    var grid = el.querySelector('[data-zsg-grid]'), all = el.querySelector('[data-zsg-all]');
    function showGrid(on) {
      grid.hidden = !on; dialEl.hidden = on; all.setAttribute('aria-expanded', on); all.textContent = on ? 'Back to swiping' : 'Know your size?';
      hint.textContent = on ? 'Tap your size' : (coarse ? 'Swipe or tap to change the size' : 'Drag or click to change the size');
      if (on) {
        var b = grid.querySelector('.is-on') || grid.firstElementChild; b.focus({ preventScroll: true });
        grid.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' });
      } else dial.sync();
    }
    if (grid) {
      all.addEventListener('click', function () { showGrid(grid.hidden); });
      grid.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { var i = +b.dataset.i; clearInput(); pick(i, false); showGrid(false); dial.set(i, false); dialEl.focus({ preventScroll: true });
          var st = el.querySelector('.zsg-stage'); if (st.getBoundingClientRect().top < 0) st.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' }); });
      });
    }
    if (hint && !coarse) hint.textContent = hint.textContent.replace('Swipe or tap', 'Drag or click').replace('Tap', 'Click');
    function clearInput() { measured = null; if (input) { input.value = ''; out.innerHTML = ''; out.className = 'zsg-measure__out'; if (unit) unit.textContent = K.unit || 'mm'; } }

    /* visuals */
    var ringBox = el.querySelector('[data-zsg-ring]'), tape = el.querySelector('[data-zsg-tape]'), form = el.querySelector('[data-zsg-form]'), wrist = el.querySelector('[data-zsg-wrist]');
    if (tape) buildTape(); if (form) buildForm();

    // Ring: real millimetres (the scale only shrinks a ring too wide for the stage, and says so).
    // Bangle: drawn to fit; at 54 to 76 mm across, a bangle is wider than most phones.
    function sizeRing() {
      if (!ringBox) return;
      var r = rows[cur], ratio = num(ringBox.dataset.ratio), room = Math.max(120, ringBox.parentNode.getBoundingClientRect().width - 8);
      if (kind === 'bangle') {
        var maxD = num(rows[rows.length - 1].d), h = Math.min(room, 190);
        ringBox.style.width = (h * num(r.d) / maxD).toFixed(1) + 'px';
        ringBox.parentNode.style.minHeight = (h + 30).toFixed(0) + 'px';
      } else {
        // Calibrated: the ring takes the stage's full width, so even size 30 shows at true size to lay a ring on.
        el.classList.toggle('is-actual', scale().real);
        var s = scale(), want = num(r.d) / ratio * s.v, fit = Math.min(1, room / want);
        var tallest = Math.min(room, num(rows[rows.length - 1].d) / ratio * s.v);
        ringBox.style.width = (want * fit).toFixed(1) + 'px';
        ringBox.parentNode.style.minHeight = (tallest + 30).toFixed(0) + 'px'; // fixed height: the dial never moves under a finger
        if (badge) {
          var pct = Math.round(fit * 100);
          badge.querySelector('span').textContent = !s.real ? '' : pct < 100 ? 'Shown at ' + pct + '% of actual size.' : 'Shown at actual size.';
          badge.querySelector('em').textContent = s.real ? 'Redo the card' : 'Match your ring';
          if (matchTip) matchTip.hidden = !s.real;
          badge.classList.toggle('is-real', s.real);
        }
      }
      dim.textContent = r.d + ' mm across';
      if (grid) grid.querySelectorAll('button').forEach(function (b) { var on = +b.dataset.i === cur; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    }
    function buildTape() {
      var html = '';
      rows.forEach(function (r, i) {
        html += '<button type="button" class="zsg-tape__seg" data-i="' + i + '" aria-label="' + esc('Size ' + r.v + ', ' + r.name + ', wrists ' + r.lo + ' to ' + r.hi + ' mm') + '">' + r.v + '</button>';
      });
      tape.innerHTML = html;
      tape.querySelectorAll('.zsg-tape__seg').forEach(function (b) {
        // Keep their measurement: tapping other sizes shows how each would sit on their wrist.
        b.addEventListener('click', function () { pick(+b.dataset.i, false); });
      });
    }
    // Bracelet on a wrist, seen end-on, both drawn to one scale (0.3 units per mm around).
    // Without a measurement the wrist is the middle of the chosen size, so it sits just right.
    function paintTape() {
      if (!tape) return;
      var r = rows[cur], lo = num(r.lo), hi = num(r.hi);
      tape.querySelectorAll('.zsg-tape__seg').forEach(function (b, i) { b.classList.toggle('is-on', i === cur); b.setAttribute('aria-pressed', i === cur); });
      var w = measured != null ? measured : (lo + hi) / 2, k = 0.3, fit = measured == null ? '' : measured < lo ? 'loose' : measured >= hi ? 'tight' : 'ok';
      var arm = wrist.querySelector('.zsg-wrist__arm'), band = wrist.querySelectorAll('.zsg-wrist__line, .zsg-wrist__beads');
      arm.setAttribute('r', Math.max(16, Math.min(74, w * k - 4)).toFixed(1));
      band.forEach(function (c) { c.setAttribute('r', Math.min(74, hi * k).toFixed(1)); });
      wrist.querySelector('text').textContent = measured != null ? 'You' : 'Wrist';
      wrist.setAttribute('data-fit', fit);
      dim.textContent = fit === 'ok' ? 'Fits your wrist' : fit === 'loose' ? 'Loose on your wrist' : fit === 'tight' ? 'Too small for your wrist' : '';
    }
    // Dress form: every length drawn faintly, the chosen one in gold. Depths: DROP (top of file).
    function depth(L) {
      for (var i = 1; i < DROP.length; i++) if (L <= DROP[i][0]) {
        var a = DROP[i - 1], b = DROP[i]; return Math.round(a[1] + (b[1] - a[1]) * (L - a[0]) / (b[0] - a[0]));
      }
      return DROP[DROP.length - 1][1];
    }
    function chainPath(L) {
      var y = depth(L), d = y - 80, spread = Math.min(d * 0.2, 26), w = 14 + Math.min(d, 140) * 0.28;
      return 'M171 80C' + (171 - spread).toFixed(1) + ' ' + (80 + d * 0.62).toFixed(1) + ' ' + (200 - w).toFixed(1) + ' ' + y + ' 200 ' + y +
        'C' + (200 + w).toFixed(1) + ' ' + y + ' ' + (229 + spread).toFixed(1) + ' ' + (80 + d * 0.62).toFixed(1) + ' 229 80';
    }
    function buildForm() {
      var g = form.querySelector('[data-zsg-chains]'), html = '';
      rows.forEach(function (r, i) {
        var p = chainPath(num(r.v));
        html += '<g class="zsg-form__chain" data-i="' + i + '"><path class="zsg-form__hit" d="' + p + '"/><path class="zsg-form__line" d="' + p + '"/></g>';
      });
      g.innerHTML = html;
      g.querySelectorAll('.zsg-form__chain').forEach(function (c) {
        c.addEventListener('click', function () { var i = +c.dataset.i; dial.set(i, true); pick(i, false); });
      });
    }
    function paintForm() {
      if (!form) return;
      // Match by data-i, not DOM position: the chosen chain is moved last so it draws on top.
      form.querySelectorAll('.zsg-form__chain').forEach(function (c) { c.classList.toggle('is-on', +c.dataset.i === cur); });
      var on = form.querySelector('.zsg-form__chain.is-on'); if (on) on.parentNode.appendChild(on);
      var r = rows[cur], y = depth(num(r.v)), tag = form.querySelector('[data-zsg-tag]');
      tag.style.transform = 'translateY(' + Math.min(y, 452) + 'px)';
      tag.querySelector('text').textContent = r.v + ' in';
    }

    function pick(i, fromInput) {
      cur = i; var r = rows[i];
      big.innerHTML = K.big(r); label.textContent = K.label(r); meta.textContent = K.meta(r);
      if (!still) { big.classList.remove('is-new'); void big.offsetWidth; big.classList.add('is-new'); }
      rows.forEach(function (o, n) { o.tr.classList.toggle('is-on', n === i); o.tr.querySelector('th').setAttribute('aria-current', n === i ? 'true' : 'false'); });
      sizeRing(); paintTape(); paintForm(); paintSave();
      if (wa) {
        var msg = 'Hi ZOCI, ' + (guide.product ? 'about the ' + guide.product + ': ' : '') +
          (measured != null ? 'my ' + K.what + ' measures ' + fmt(measured) + ' mm. Is ' : 'is ') + K.saved(r).split(' · ')[0].toLowerCase() + ' right for me?';
        wa.href = wa.dataset.base + '?text=' + encodeURIComponent(msg);
      }
      if (fromInput && live) live.textContent = K.label(r) + ' ' + r.v + '. ' + K.meta(r);
    }
    function paintSave() {
      if (!save) return;
      var fit = get(FIT) || {}, r = rows[cur], held = fit[kind] && fit[kind].v === r.v, what = 'size ' + r.v;
      save.classList.toggle('is-saved', !!held);
      // Sent here by Add to Cart / Buy Now (gate): say what Save will do next.
      save.querySelector('span').textContent = guide.adding === 'bag' ? 'Add to bag in ' + what
        : guide.adding === 'buy' ? 'Save ' + what + ' and continue'
        : held ? 'Size ' + r.v + ' is saved' : 'Save ' + what;
    }
    document.addEventListener('zoci:fitmode', paintSave);
    if (save) save.addEventListener('click', function () {
      // "16" still waiting for "size 16 or 16 mm?": answer that first, never save a guess.
      if (out && out.classList.contains('is-ask')) { out.classList.remove('is-nudge'); void out.offsetWidth; out.classList.add('is-nudge'); out.querySelector('.zsg-pick').focus(); return; }
      var fit = get(FIT) || {}, r = rows[cur];
      fit[kind] = { v: r.v, text: K.saved(r) }; put(FIT, fit); paintSave();
      document.dispatchEvent(new CustomEvent('zoci:fit', { detail: { kind: kind } }));
      if (guide.dialog) setTimeout(function () { guide.close(); }, 650);
    });

    if (input) {
      var lastKey = '';
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
      // Read once typing pauses: "16" must never pass through size 1 on the way.
      var wait = 0;
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^0-9.,\-\/ ]/g, '').slice(0, 8);
        clearTimeout(wait); wait = setTimeout(take, 350);
      });
      input.addEventListener('blur', function () { if (wait) { clearTimeout(wait); take(); } });
      function take() {
        wait = 0;
        var got = read(K, rows, input.value.trim());
        if (!got) { if (unit) unit.textContent = K.unit || 'mm'; out.innerHTML = ''; out.className = 'zsg-measure__out'; measured = null; paintTape(); return; }
        if (got.wait) { if (unit) unit.textContent = K.unit || 'mm'; out.className = 'zsg-measure__out'; out.innerHTML = esc(K.wait); measured = null; paintTape(); return show(); }
        if (got.ask) { // two honest readings: ask, never guess a ring size
          out.className = 'zsg-measure__out is-ask';
          out.innerHTML = 'Did you mean <button type="button" class="zsg-pick" data-a="0">' + esc(got.ask[0].said) + '</button> or <button type="button" class="zsg-pick" data-a="1">' + esc(got.ask[1].said) + '</button>?';
          out.querySelectorAll('[data-a]').forEach(function (b) { b.addEventListener('click', function () { apply(got.ask[+b.dataset.a]); }); });
          return show();
        }
        apply(got); show();
      }
      // The answer can land under the drawer's Save bar on a short phone: bring it up (scroll-margin clears the bar).
      function show() { if (guide.dialog && out.textContent) out.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' }); }
      function apply(got) {
        if (unit) unit.textContent = got.unit || K.unit || 'mm';
        var i, msg, warn = false;
        if (got.big) {
          i = rows.length - 1; measured = null; warn = true;
          msg = 'That is larger than our biggest size. Message us on WhatsApp and we will help.';
        } else if (kind === 'chain') { // chains come in set lengths: the nearest one, and say when it is not the same
          i = 0; rows.forEach(function (r, n) { if (Math.abs(num(r.mm) - got.m) < Math.abs(num(rows[i].mm) - got.m)) i = n; });
          var len = '<b>' + esc(rows[i].v) + ' in, ' + esc(rows[i].name) + '</b>';
          if (got.m < num(rows[0].mm) - 25) { warn = true; msg = got.note + 'Shorter than our shortest, so ' + len + ' is your closest.'; }
          else if (got.m > num(rows[rows.length - 1].mm) + 25) { warn = true; msg = got.note + 'Longer than our longest, so ' + len + ' is your closest.'; }
          else msg = got.note + (Math.abs(num(rows[i].mm) - got.m) <= 13 ? 'That is ' + len + '.' : 'Closest length: ' + len + '.');
        } else {
          measured = got.unit === 'size' ? null : got.m;
          i = got.i != null ? got.i : kind === 'bracelet' ? (function () { for (var n = 0; n < rows.length; n++) if (got.m < num(rows[n].hi)) return n; return -1; })()
            : (function () { for (var n = 0; n < rows.length; n++) if (num(rows[n].c) >= got.m - 0.3) return n; return -1; })();
          var name = '<b>size ' + esc(rows[Math.max(0, i)].v) + '</b>';
          if (i < 0) { i = rows.length - 1; warn = true; msg = got.note + 'That is larger than our biggest size. Message us on WhatsApp and we will help.'; }
          else if (kind === 'bracelet' && got.m < num(rows[0].lo)) { warn = true; msg = got.note + 'That is under ' + rows[0].lo + ' mm, so ' + name + ' is your closest.'; }
          else if (kind !== 'bracelet' && got.m < num(rows[0].c) - 2) { warn = true; msg = got.note + 'That is smaller than our smallest, so ' + name + ' is your closest.'; }
          else if (got.unit === 'size') msg = 'Got it: ' + name + '.';
          else {
            var exact = got.exact != null ? got.exact : kind === 'bracelet' || Math.abs(num(rows[i].c) - got.m) <= K.exact;
            msg = got.note + (exact ? 'That is ' + name + '.' : 'Between sizes, so we went one up: ' + name + '.');
          }
        }
        out.className = 'zsg-measure__out ' + (warn ? 'is-warn' : 'is-ok');
        out.innerHTML = msg;
        var key = i + '|' + kind; if (key !== lastKey) { dial.set(i, true); lastKey = key; }
        pick(i, true);
      }
    }
    var how = el.querySelector('[data-zsg-how]');
    if (how) how.addEventListener('click', function () { var h = el.querySelector('.zsg-side .zsg-h'); h.setAttribute('tabindex', '-1'); h.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' }); h.focus({ preventScroll: true }); });
    if (badge) badge.addEventListener('click', function () { guide.calibrate(self); });
    // Below the steps: back up to the box with the number, or the ring-on-screen route.
    var backBtn = el.querySelector('[data-zsg-back]'), alt = el.querySelector('[data-zsg-match-start]');
    if (backBtn) backBtn.addEventListener('click', function () {
      input.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' }); input.focus({ preventScroll: true });
    });
    if (alt) alt.addEventListener('click', function () {
      if (scale().real) el.querySelector('.zsg-stage').scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
      else guide.calibrate(self);
    });
    // Chart: opens on the size showing in the stage, not on size 1.
    var chart = el.querySelector('.zsg-chart');
    if (chart) chart.addEventListener('toggle', function () {
      if (!chart.open) return;
      var box = chart.querySelector('.zsg-chart__scroll'), tr = rows[cur].tr;
      if (box.scrollHeight > box.clientHeight) box.scrollTop = tr.offsetTop - box.clientHeight / 2 + tr.offsetHeight / 2;
      if (guide.dialog) chart.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' });
    });
    rows.forEach(function (o, i) {
      o.tr.querySelector('.zsg-row').addEventListener('click', function () {
        clearInput(); dial.set(i, true); pick(i, false);
        var stage = el.querySelector('.zsg-stage'), top = stage.getBoundingClientRect().top;
        if (top < 0) stage.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      });
    });

    this.show = function () { dial.sync(); sizeRing(); };
    this.refresh = function () { sizeRing(); };
    // Start on the saved size, else the table's starred row.
    var fit = get(FIT) || {}, start = 0;
    rows.forEach(function (r, i) { if (r.tr.hasAttribute('data-start')) start = i; });
    if (fit[kind]) rows.forEach(function (r, i) { if (r.v === fit[kind].v) start = i; });
    dial.set(start, false); pick(start, false);
    var ro = window.ResizeObserver && new ResizeObserver(function () { dial.sync(); sizeRing(); });
    if (ro) ro.observe(el);
  }

  /* ---------- The guide: tabs, calibration, dialog ---------- */
  function Guide(root) {
    var self = this, panels = {}, tabs = root.querySelectorAll('[role=tab]');
    this.product = root.dataset.product || '';
    this.dialog = root.closest('dialog');
    root.querySelectorAll('[data-zsg-panel]').forEach(function (p) { var o = new Panel(p, self); panels[o.kind] = o; });

    this.show = function (kind, focus) {
      if (!panels[kind]) return;
      tabs.forEach(function (t) {
        var on = t.dataset.tab === kind;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      root.querySelectorAll('[data-zsg-panel]').forEach(function (p) { p.hidden = p.dataset.kind !== kind; });
      cal.hidden = true;
      requestAnimationFrame(function () { panels[kind].show(); });
      if (root.dataset.context === 'page') history.replaceState(null, '', '#' + kind + 's');
      self.kind = kind;
    };
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { self.show(t.dataset.tab); });
      t.addEventListener('keydown', function (e) {
        var d = { ArrowLeft: -1, ArrowRight: 1 }[e.key]; if (!d) return;
        e.preventDefault(); self.show(tabs[(n + d + tabs.length) % tabs.length].dataset.tab, true);
      });
    });

    // Calibration, step 1 of 2: hold a card to the screen and drag the outline to the card's short edge.
    // Step 2 is the ring tab itself: the circle is now true to size, so they lay their ring on it.
    var cal = root.querySelector('[data-zsg-cal]'), card = cal.querySelector('.zsg-cal__card'), frame = cal.querySelector('.zsg-cal__frame'), v = 6, back = null;
    function paintCard() {
      v = Math.max(3, Math.min(9.5, v));
      card.style.width = (CARD_MM * v).toFixed(1) + 'px';
      frame.setAttribute('aria-valuenow', v.toFixed(2)); frame.setAttribute('aria-valuetext', Math.round(CARD_MM * v) + ' pixels wide');
    }
    cal.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { v += num(b.dataset.step); paintCard(); });
    });
    var grab = null; // drag anywhere on the frame; the outline is centred, so it grows by twice the finger's travel
    frame.addEventListener('pointerdown', function (e) { grab = { x: e.clientX, v: v }; frame.setPointerCapture(e.pointerId); frame.classList.add('is-grabbing'); });
    frame.addEventListener('pointermove', function (e) { if (!grab) return; v = grab.v + (e.clientX - grab.x) * 2 / CARD_MM; paintCard(); });
    ['pointerup', 'pointercancel'].forEach(function (t) { frame.addEventListener(t, function () { grab = null; frame.classList.remove('is-grabbing'); }); });
    frame.addEventListener('keydown', function (e) {
      var d = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[e.key]; if (!d) return;
      e.preventDefault(); v += d * (e.shiftKey ? 0.1 : 0.02); paintCard();
    });
    this.calibrate = function (panel) {
      back = panel; v = scale().v; paintCard();
      cal.querySelector('[data-zsg-cal-reset]').hidden = !scale().real;
      root.querySelectorAll('[data-zsg-panel]').forEach(function (p) { p.hidden = true; });
      cal.hidden = false; cal.querySelector('h3').focus({ preventScroll: true }); cal.scrollIntoView({ block: 'start' });
    };
    function done(save) {
      if (save === true) put(PXMM, v); else if (save === false) drop(PXMM);
      cal.hidden = true; Object.keys(panels).forEach(function (k) { panels[k].refresh(); });
      self.show(back ? back.kind : self.kind);
      var p = root.querySelector('[data-zsg-panel]:not([hidden])'), stage = p && p.querySelector('.zsg-stage');
      if (stage) requestAnimationFrame(function () { stage.scrollIntoView({ block: 'start' }); });
      var b = p && (save === true ? p.querySelector('.zsg-dial') : p.querySelector('[data-zsg-scale]')); if (b) b.focus({ preventScroll: true });
    }
    cal.querySelector('[data-zsg-cal-done]').addEventListener('click', function () { done(true); });
    cal.querySelector('[data-zsg-cal-reset]').addEventListener('click', function () { done(false); });
    cal.querySelector('[data-zsg-cal-cancel]').addEventListener('click', function () { done(null); });

    // Dialog (product page): native top layer, slide in, close on Esc / backdrop / button.
    var d = this.dialog, lastFocus;
    this.open = function (kind) {
      if (!d) return;
      lastFocus = document.activeElement;
      self.show(kind || root.dataset.start);
      d.classList.remove('is-closing'); d.showModal();
      var body = d.querySelector('.zsg-dialog__body'); if (body) body.scrollTop = 0;
      document.documentElement.classList.add('zsg-lock');
      requestAnimationFrame(function () { panels[self.kind].show(); });
    };
    this.close = function () {
      if (!d || !d.open) return;
      if (still) return finish();
      d.classList.add('is-closing');
      setTimeout(finish, 260);
    };
    function finish() { d.classList.remove('is-closing'); d.close(); }
    if (d) {
      d.addEventListener('close', function () { document.documentElement.classList.remove('zsg-lock'); if (lastFocus) lastFocus.focus({ preventScroll: true }); });
      d.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
      d.addEventListener('click', function (e) { if (e.target === d) self.close(); });
      d.querySelectorAll('[data-zsg-close]').forEach(function (b) { b.addEventListener('click', self.close); });
    }

    var hash = (location.hash || '').replace('#', '').replace(/s$/, '');
    self.show(root.dataset.context === 'page' && panels[hash] ? hash : root.dataset.start);
  }

  /* ---------- Product-page trigger: opens the drawer, shows the saved size ---------- */
  function Trigger(btn) {
    var guide = document.getElementById(btn.getAttribute('aria-controls')).querySelector('zoci-size-guide').zsg;
    var kind = btn.dataset.kind, note = btn.querySelector('[data-zoci-fit-note]'), plain = note.textContent;
    var cta = btn.querySelector('[data-zoci-fit-cta]'), props = btn.parentNode.querySelectorAll('[data-zoci-fit-prop]');
    btn.addEventListener('click', function () { guide.open(kind); });
    function paint() {
      var fit = (get(FIT) || {})[kind];
      btn.classList.toggle('is-saved', !!fit);
      var parts = fit ? fit.text.split(' · ') : [];
      // e.g. "11 (51.2 mm)", "M (152–165 mm)", "2-6 (60.3 mm across)": what the studio reads on the order.
      props.forEach(function (p) { p.disabled = !fit; p.value = fit ? fit.v + (parts[1] ? ' (' + parts[1] + ')' : '') : ''; });
      note.textContent = fit ? (props.length ? parts[0] + ' · added to your order' : 'Saved: ' + parts[0]) : plain;
      if (cta) cta.textContent = fit && props.length ? 'Change' : 'Size guide';
    }
    document.addEventListener('zoci:fit', paint); paint();
    if (btn.hasAttribute('data-required')) gate(btn, guide, kind);
    if (location.hash === '#size') setTimeout(function () { guide.open(kind); }, 300); // from a card's "Choose size"
  }

  /* Required size (rings, bracelets, bangles): Add to Cart, the sticky bar and Razorpay Buy Now wait until a size is saved.
     Caught on window in the capture phase, so it runs before the theme's form handler and before the
     click reaches the Buy Now widget. After Save, Add to Cart carries on by itself. */
  function gate(btn, guide, kind) {
    var sid = btn.getAttribute('aria-controls').replace('zsg-dialog-', ''), pending = null;
    var forms = ['product-form-' + sid, 'sticky-addcart-form-' + sid];
    var d = document.getElementById(btn.getAttribute('aria-controls')), need = d.querySelector('[data-zsg-need]');
    var note = btn.querySelector('[data-zoci-fit-note]'), noun = btn.dataset.noun || 'piece';
    function mode(m) { guide.adding = m; document.dispatchEvent(new CustomEvent('zoci:fitmode')); }
    function sized() { return !!(get(FIT) || {})[kind]; }
    function ours(t) {
      if (!t || !t.closest) return null;
      if (t.closest('magic-checkout-btn, .magic-buy-btn')) return { buyNow: true };
      var f = t.closest('form'), add = t.closest('[name="add"]');
      if (add && f && forms.indexOf(f.getAttribute('id')) > -1) return { button: add };
      return null;
    }
    function hold(e, hit) {
      e.preventDefault(); e.stopImmediatePropagation();
      pending = hit;
      btn.classList.add('is-needed');
      if (need) need.hidden = false;
      mode(hit.buyNow ? 'buy' : 'bag');
      guide.open(kind);
    }
    window.addEventListener('click', function (e) {
      if (sized()) return;
      var hit = ours(e.target); if (hit) hold(e, hit);
    }, true);
    window.addEventListener('submit', function (e) {
      if (sized() || forms.indexOf(e.target.getAttribute('id')) < 0) return; // getAttribute: the form's own input named "id" shadows .id
      hold(e, { button: e.target.querySelector('[name="add"]') });
    }, true);
    document.addEventListener('zoci:fit', function (e) {
      if (e.detail && e.detail.kind !== kind) return; // saved another tab: this piece still needs its own size
      btn.classList.remove('is-needed'); if (need) need.hidden = true;
      var go = pending; pending = null; mode(null);
      if (go && go.button) setTimeout(function () { go.button.click(); }, 750); // after the drawer has closed
      else if (go && go.buyNow) note.textContent += '. Tap Buy Now again';
    });
    // Closed without saving: bring the size row into view and say why the button did nothing.
    d.addEventListener('close', function () {
      var was = pending; pending = null; mode(null); if (need) need.hidden = true;
      if (sized() || !was) return;
      note.textContent = 'Pick your size to add this ' + noun;
      btn.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      btn.focus({ preventScroll: true });
    });
  }

  function boot() {
    document.querySelectorAll('zoci-size-guide').forEach(function (g) { if (!g.zsg) g.zsg = new Guide(g); });
    document.querySelectorAll('[data-zsg-open]').forEach(function (b) { if (!b.zsgReady) { b.zsgReady = true; Trigger(b); } });
  }
  window.ZociSizeGuide = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
